// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__2ApcI","containerItemsCenter":"Skeleton_containerItemsCenter__2ckbw"};